import { createContext, useContext } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const resolveUrl = (url) => {
  if (!url) return "";
  if (url.startsWith('data:')) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const uploadsMatch = url.match(/\/api\/uploads\/.+$/);
    if (uploadsMatch) return `${BACKEND_URL}${uploadsMatch[0]}`;
    const legacyMatch = url.match(/(\/uploads\/.+)$/);
    if (legacyMatch) return `${BACKEND_URL}/api${legacyMatch[1]}`;
    return url;
  }
  if (url.startsWith('/uploads/') && !url.startsWith('/api/uploads/'))
    return `${BACKEND_URL}/api${url}`;
  if (url.startsWith('/api/'))
    return `${BACKEND_URL}${url}`;
  return `${BACKEND_URL}${url}`;
};

// Context that exposes the AdminDashboard controller (all state + handlers).
// Child panels consume it via useAdmin() instead of receiving dozens of props.
export const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);
